var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2, _path18, _path19, _path20, _path21, _path22, _path23, _g3, _path24, _path25, _g4, _path26, _path27, _g5, _path28, _g6, _path29, _g7, _path30, _path31, _path32, _g8, _path33, _path34, _g9, _path35, _path36, _g0, _path37, _g1, _path38, _g10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreparingService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 152,
    viewBox: "0 0 130 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.301 24.7645C104.879 21.2059 99.449 20.7452 95.5065 23.4494C95.235 18.8415 91.7674 14.899 87.0202 14.1995C82.4621 13.5299 78.1756 16.0606 76.4354 20.0969C75.3591 15.6625 71.3257 12.4138 66.57 12.502C61.075 12.61 56.7074 17.1525 56.8154 22.6475L57.0671 35.4317C57.1737 40.8599 61.6081 45.1877 67.0135 45.1877C67.0804 45.1877 67.1472 45.1877 67.214 45.1863C70.3489 45.1251 73.1156 43.6181 74.8956 41.3149C76.3245 44.0347 78.9874 46.0592 82.2588 46.5412C82.7507 46.6137 83.2384 46.6478 83.7204 46.6478C83.8327 46.6478 83.945 46.6435 84.0573 46.6407C84.2663 46.9094 84.4924 47.1696 84.7326 47.4198C86.6861 49.4529 89.295 50.4751 91.9081 50.4751C94.5213 50.4751 96.8742 49.5524 98.8035 47.697L108.021 38.8354C111.983 35.0265 112.107 28.7254 108.298 24.763L108.301 24.7645Z",
    fill: "#FFEDD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.955 64.0938C112.955 86.7235 91.5866 96.1482 65.2276 96.1482C38.8687 96.1482 17.5 86.7235 17.5 64.0938C17.5 41.464 38.8687 28.8433 65.2276 28.8433C91.5866 28.8433 112.955 41.464 112.955 64.0938Z",
    fill: "#FFEDD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.689 66.4056C99.689 82.3888 84.2603 90.0505 65.2276 90.0505C46.1948 90.0505 30.7661 82.3888 30.7661 66.4056C30.7661 50.4225 46.1948 42.512 65.2276 42.512C84.2603 42.512 99.689 50.4211 99.689 66.4056Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_489_6182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 42,
    width: 70,
    height: 49
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.689 66.4056C99.689 82.3888 84.2603 90.0505 65.2276 90.0505C46.1948 90.0505 30.7661 82.3888 30.7661 66.4056C30.7661 50.4225 46.1948 42.512 65.2276 42.512C84.2603 42.512 99.689 50.4211 99.689 66.4056Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_489_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8757 87.6236C48.3458 87.6236 53.5908 82.3785 53.5908 75.9085C53.5908 69.4384 48.3458 64.1934 41.8757 64.1934C35.4057 64.1934 30.1606 69.4384 30.1606 75.9085C30.1606 82.3785 35.4057 87.6236 41.8757 87.6236Z",
    fill: "#B7654F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5798 87.6236C95.0499 87.6236 100.295 82.3785 100.295 75.9085C100.295 69.4384 95.0499 64.1934 88.5798 64.1934C82.1098 64.1934 76.8647 69.4384 76.8647 75.9085C76.8647 82.3785 82.1098 87.6236 88.5798 87.6236Z",
    fill: "#B7654F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2266 72.8008L63.2253 70.4644L65.5617 69.1294L67.2305 70.4644L65.8954 72.8008H64.2266Z",
    fill: "#AF4F3C"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4641 64.2287C54.3798 66.313 51.7396 67.0537 49.7961 65.1102C47.8526 63.1667 48.5933 60.5279 50.6776 58.4423C52.7619 56.358 55.402 55.6173 57.3455 57.5608C59.289 59.5043 58.5483 62.143 56.4641 64.2287Z",
    fill: "#3B090A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5178 70.028C55.4335 72.1123 52.7934 72.853 50.8498 70.9095C48.9063 68.966 49.6471 66.3273 51.7313 64.2416C53.8156 62.1573 56.4557 61.4166 58.3993 63.3601C60.3428 65.3036 59.602 67.9423 57.5178 70.028Z",
    fill: "#3B090A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3113 61.9272C53.3332 62.9053 52.1787 63.339 51.4422 62.6025C50.7058 61.866 51.138 60.7116 52.1176 59.7334C53.0957 58.7553 54.2502 58.3217 54.9866 59.0581C55.7231 59.7946 55.2909 60.949 54.3113 61.9272Z",
    fill: "#FFF5E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.4943 68.7162C54.6071 69.6034 53.5266 69.9631 52.7901 69.2266C52.0537 68.4901 52.4134 67.4096 53.3005 66.5225C54.1877 65.6353 55.2682 65.2756 56.0047 66.0121C56.7411 66.7485 56.3814 67.829 55.4943 68.7162Z",
    fill: "#FFC160"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.914 64.0884C55.4932 64.5092 54.97 64.6671 54.596 64.2931C54.2221 63.9192 54.3799 63.3946 54.8008 62.9752C55.2216 62.5558 55.7448 62.3965 56.1187 62.7705C56.4926 63.1444 56.3348 63.669 55.914 64.0884Z",
    fill: "#B7654F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3505 71.0133C67.342 71.0133 67.3349 71.0133 67.3264 71.0133C66.5942 71.0062 65.8904 70.6508 65.2265 69.9541C64.5625 70.6508 63.8588 71.0062 63.1266 71.0133C63.1195 71.0133 63.1109 71.0133 63.1024 71.0133C61.9664 71.0133 61.2783 70.1674 61.203 70.0707C60.9627 69.7608 61.0196 69.3144 61.3295 69.0727C61.638 68.8338 62.0816 68.8878 62.3219 69.1935C62.3375 69.212 62.6602 69.5916 63.1038 69.5916C63.1095 69.5916 63.1152 69.5916 63.1209 69.5916C63.5588 69.5816 64.0607 69.2106 64.5739 68.5196C64.7075 68.3391 64.9194 68.2324 65.144 68.2324H65.3033C65.5279 68.2324 65.7397 68.3391 65.8734 68.5196C66.3866 69.2106 66.8885 69.5816 67.3264 69.5916C67.3321 69.5916 67.3378 69.5916 67.3434 69.5916C67.7956 69.5916 68.1226 69.1978 68.1254 69.1935C68.3657 68.8836 68.8107 68.8296 69.1206 69.0698C69.4305 69.3101 69.4846 69.7594 69.2443 70.0707C69.1689 70.1674 68.4808 71.0133 67.3449 71.0133H67.3505Z",
    fill: "#3B090A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6629 75.0554C83.4809 75.0554 83.2989 74.9857 83.1596 74.8478C82.8824 74.5705 82.8824 74.1198 83.1596 73.8426L86.1978 70.8044C86.4751 70.5271 86.9258 70.5271 87.203 70.8044C87.4802 71.0816 87.4802 71.5323 87.203 71.8095L84.1648 74.8478C84.0254 74.9871 83.8434 75.0554 83.6615 75.0554H83.6629Z",
    fill: "#AF4F3C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4903 75.0552C87.3083 75.0552 87.1263 74.9856 86.987 74.8477C86.7097 74.5704 86.7097 74.1197 86.987 73.8425L88.7485 72.081C89.0258 71.8037 89.4764 71.8037 89.7537 72.081C90.0309 72.3582 90.0309 72.8089 89.7537 73.0861L87.9921 74.8477C87.8528 74.987 87.6708 75.0552 87.4889 75.0552H87.4903Z",
    fill: "#AF4F3C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2517 73.2938C89.0698 73.2938 88.8878 73.2241 88.7485 73.0862C88.4712 72.809 88.4712 72.3583 88.7485 72.081L90.0266 70.8029C90.3038 70.5257 90.7545 70.5257 91.0318 70.8029C91.309 71.0801 91.309 71.5308 91.0318 71.8081L89.7536 73.0862C89.6143 73.2255 89.4323 73.2938 89.2503 73.2938H89.2517Z",
    fill: "#AF4F3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3162 75.0554C91.1342 75.0554 90.9522 74.9857 90.8129 74.8478C90.5357 74.5705 90.5357 74.1198 90.8129 73.8426L93.8512 70.8044C94.1284 70.5271 94.5791 70.5271 94.8563 70.8044C95.1336 71.0816 95.1336 71.5323 94.8563 71.8095L91.8181 74.8478C91.6787 74.9871 91.4968 75.0554 91.3148 75.0554H91.3162Z",
    fill: "#AF4F3C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0989 75.0554C35.9169 75.0554 35.735 74.9857 35.5956 74.8478C35.3184 74.5705 35.3184 74.1198 35.5956 73.8426L38.6339 70.8044C38.9111 70.5271 39.3618 70.5271 39.639 70.8044C39.9163 71.0816 39.9163 71.5323 39.639 71.8095L36.6008 74.8478C36.4615 74.9871 36.2795 75.0554 36.0975 75.0554H36.0989Z",
    fill: "#AF4F3C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9261 75.0552C39.7441 75.0552 39.5621 74.9856 39.4228 74.8477C39.1455 74.5704 39.1455 74.1197 39.4228 73.8425L41.1843 72.081C41.4615 71.8037 41.9122 71.8037 42.1895 72.081C42.4667 72.3582 42.4667 72.8089 42.1895 73.0861L40.4279 74.8477C40.2886 74.987 40.1066 75.0552 39.9246 75.0552H39.9261Z",
    fill: "#AF4F3C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6863 73.2938C41.5043 73.2938 41.3224 73.2241 41.183 73.0862C40.9058 72.809 40.9058 72.3583 41.183 72.081L42.4612 70.8029C42.7384 70.5257 43.1891 70.5257 43.4663 70.8029C43.7436 71.0801 43.7436 71.5308 43.4663 71.8081L42.1882 73.0862C42.0489 73.2255 41.8669 73.2938 41.6849 73.2938H41.6863Z",
    fill: "#AF4F3C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7522 75.0556C43.5703 75.0556 43.3883 74.9859 43.2489 74.848C42.9717 74.5708 42.9717 74.1201 43.2489 73.8429L46.2872 70.8046C46.5644 70.5274 47.0151 70.5274 47.2924 70.8046C47.5696 71.0818 47.5696 71.5325 47.2924 71.8098L44.2541 74.848C44.1148 74.9874 43.9328 75.0556 43.7508 75.0556H43.7522Z",
    fill: "#AF4F3C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_489_6182",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 12,
    width: 56,
    height: 31
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.273 42.4406L108.023 38.8351C111.986 35.0263 112.11 28.7252 108.301 24.7628C104.879 21.2042 99.449 20.7435 95.5065 23.4477C95.235 18.8398 91.7674 14.8974 87.0202 14.1979C82.4621 13.5282 78.1756 16.0589 76.4354 20.0952C75.3591 15.6623 71.3257 12.4136 66.57 12.5018C61.075 12.6098 56.7074 17.1522 56.8154 22.6473L56.9462 29.2754C59.6362 28.9882 62.4029 28.8432 65.2278 28.8432C81.3674 28.8432 95.6359 33.5761 104.273 42.4406Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_489_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3292 15.0371C60.1835 34.7793 95.3189 45.6556 111.75 28.1981L114.197 48.273L45.7529 38.7843L56.3292 15.0371Z",
    fill: "#FFDEBE"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0433 58.7683C76.5756 58.7681 73.5717 60.4515 71.9029 64.4568C74.9067 65.4579 76.2418 66.1255 78.3114 68.0848",
    stroke: "#3B090A",
    strokeWidth: 2.33632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2252 69.6968C63.6491 69.6968 63.9928 70.0405 63.9928 70.4644C63.9928 70.7618 64.1174 71.2938 64.3841 71.7383C64.6522 72.1852 64.9467 72.3669 65.2277 72.3669C65.6744 72.3669 65.9563 72.1303 66.1682 71.7065C66.3934 71.2561 66.4626 70.7136 66.4626 70.4644C66.4626 70.0405 66.8063 69.6968 67.2303 69.6968C67.6542 69.6968 67.9979 70.0405 67.9979 70.4644C67.9979 70.8828 67.9003 71.6753 67.5414 72.3931C67.1693 73.1374 66.4498 73.9021 65.2277 73.9021C64.1737 73.9021 63.4669 73.1938 63.0676 72.5282C62.6667 71.8601 62.4575 71.057 62.4575 70.4644C62.4575 70.0405 62.8012 69.6968 63.2252 69.6968Z",
    fill: "#3B090A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2366 64.2772C73.6829 63.6097 76.9092 62.4541 80.5806 63.1217",
    stroke: "#3B090A",
    strokeWidth: 2.33632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2174 111.158C71.6452 117.778 68.2323 119.084 66.0136 120.601C63.7949 122.119 63.439 123.99 64.1249 126.268C65.1183 129.567 68.269 130.353 70.5466 129.667C75.8351 128.075 85.4632 119.145 84.9121 114.2C85.3245 112.126 85.1873 110.165 84.8128 108.588C84.6251 107.799 84.3611 107.034 84.0232 106.348C83.7429 105.779 83.2024 104.826 82.2588 104.097C80.3764 102.643 77.6716 102.99 76.2174 104.872C74.2389 107.434 76.2174 107.838 76.2174 111.158Z",
    fill: "#946555"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9892 114.935C100.011 105.869 91.197 101.588 86.4121 100.581L76.5906 121.357C80.7458 124.253 93.9671 124.001 96.9892 114.935Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_489_6182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 100,
    width: 22,
    height: 23
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9892 114.935C100.011 105.869 91.197 101.588 86.4121 100.581L76.5906 121.357C80.7458 124.253 93.9671 124.001 96.9892 114.935Z",
    fill: "#946555"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_489_6182)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_489_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.065 132.035C108.297 132.683 113.064 128.965 113.712 123.733C114.359 118.5 110.642 113.733 105.409 113.085C100.176 112.438 95.4092 116.155 94.7618 121.388C94.1143 126.621 97.8316 131.388 103.065 132.035Z",
    fill: "#F46940"
  })))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9498 98.7865C75.9108 98.7352 75.9012 98.7226 75.9271 98.748C74.2267 97.0846 74.2357 93.0624 76.7605 91.3619C79.2853 89.6614 81.1149 90.5598 82.8153 92.2232C86.3261 95.6575 87.8248 102.249 86.4849 107.131C85.779 109.702 84.0607 111.873 81.3495 113.276C79.237 114.37 78.4832 112.136 77.3898 110.024C76.2964 107.912 75.2773 106.72 77.3898 105.626C78.0606 105.279 78.1363 105.003 78.1779 104.852L78.1781 104.851C78.269 104.52 78.2921 103.874 78.009 102.861C77.736 101.885 77.2624 100.872 76.7606 100.012C76.3609 99.3265 76.0529 98.9218 75.9498 98.7865Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_489_6182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 90,
    width: 13,
    height: 24
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9501 98.7865C75.9111 98.7352 75.9014 98.7226 75.9274 98.748C74.227 97.0846 74.236 93.0624 76.7608 91.3619C79.2855 89.6614 81.1151 90.5598 82.8155 92.2232C86.3264 95.6575 87.825 102.249 86.4851 107.131C85.7793 109.702 84.0609 111.873 81.3497 113.276C79.2372 114.37 78.4835 112.136 77.39 110.024C76.2966 107.912 75.2776 106.72 77.39 105.626C78.0608 105.279 78.1365 105.003 78.1781 104.852L78.1784 104.851C78.2693 104.52 78.2923 103.874 78.0092 102.861C77.7363 101.885 77.2626 100.872 76.7608 100.012C76.3611 99.3265 76.0531 98.9218 75.9501 98.7865Z",
    fill: "#946555"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_489_6182)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_489_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.8885 94.2602C84.1215 94.9076 88.8885 91.1903 89.5359 85.9574C90.1834 80.7244 86.4661 75.9574 81.2331 75.31C76.0002 74.6626 71.2332 78.3798 70.5858 83.6128C69.9383 88.8457 73.6556 93.6127 78.8885 94.2602Z",
    fill: "#F46940"
  })))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6798 106.448C72.5635 105.326 74.7423 107.226 75.3753 107.811C77.1232 109.424 79.8481 109.315 81.4615 107.567C83.0749 105.819 82.9658 103.094 81.2179 101.481C77.3502 97.9107 72.5992 96.2543 69.0355 97.5585C66.5541 98.4666 64.0835 99.8529 62.8272 103.37C62.027 105.61 63.5814 108.572 65.7469 109.557C67.8708 110.522 70.656 108.527 71.6798 106.448Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_489_6182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 97,
    width: 21,
    height: 13
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6798 106.448C72.5635 105.326 74.7423 107.226 75.3753 107.811C77.1232 109.424 79.8481 109.315 81.4615 107.567C83.0749 105.819 82.9658 103.094 81.2179 101.481C77.3502 97.9107 72.5992 96.2543 69.0355 97.5585C66.5541 98.4666 64.0835 99.8529 62.8272 103.37C62.027 105.61 63.5814 108.572 65.7469 109.557C67.8708 110.522 70.656 108.527 71.6798 106.448Z",
    fill: "#946555"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_489_6182)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_489_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4898 117.681C63.7228 118.328 68.4898 114.611 69.1372 109.378C69.7847 104.145 66.0674 99.3781 60.8345 98.7307C55.6015 98.0832 50.8345 101.8 50.1871 107.033C49.5396 112.266 53.2569 117.033 58.4898 117.681Z",
    fill: "#F46940"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_489_6182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 103,
    width: 23,
    height: 27
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2174 111.157C71.6452 117.777 68.2323 119.083 66.0136 120.601C63.7949 122.119 63.439 123.99 64.1249 126.267C65.1183 129.567 68.269 130.353 70.5466 129.667C75.8351 128.074 85.4632 119.145 84.9121 114.2C85.3245 112.125 85.1873 110.165 84.8128 108.588C84.6251 107.798 84.3611 107.034 84.0232 106.348C83.7429 105.779 83.2024 104.825 82.2588 104.097C80.3764 102.642 77.6716 102.99 76.2174 104.872C74.2389 107.433 76.2174 107.838 76.2174 111.157Z",
    fill: "#946555"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_489_6182)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_489_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.023 139.59C68.256 140.238 73.023 136.521 73.6704 131.288C74.3179 126.055 70.6006 121.288 65.3677 120.64C60.1347 119.993 55.3677 123.71 54.7203 128.943C54.0728 134.176 57.7901 138.943 63.023 139.59Z",
    fill: "#F46940"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_489_6182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 90,
    width: 13,
    height: 24
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9501 98.7865C75.9111 98.7352 75.9014 98.7226 75.9274 98.748C74.227 97.0846 74.236 93.0624 76.7608 91.3619C79.2855 89.6614 81.1151 90.5598 82.8155 92.2232C86.3264 95.6575 87.825 102.249 86.4851 107.131C85.7793 109.702 84.0609 111.873 81.3497 113.276C79.2372 114.37 78.4835 112.136 77.39 110.024C76.2966 107.912 75.2776 106.72 77.39 105.626C78.0608 105.279 78.1365 105.003 78.1781 104.852L78.1784 104.851C78.2693 104.52 78.2923 103.874 78.0092 102.861C77.7363 101.885 77.2626 100.872 76.7608 100.012C76.3611 99.3265 76.0531 98.9218 75.9501 98.7865Z",
    fill: "#946555"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_489_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M85.2789 112.291C86.4877 103.829 79.1089 99.0694 75.0796 97.5583C83.1386 100.58 85.2285 107.38 87.1676 103.225C86.0344 109.898 84.0701 120.752 85.2789 112.291Z",
    fill: "#8B5C4D"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7823 111.158C58.3546 117.778 61.7674 119.084 63.9861 120.601C66.2049 122.119 66.5608 123.99 65.8749 126.268C64.8815 129.567 61.7308 130.353 59.4532 129.667C54.1646 128.075 44.5366 119.145 45.0876 114.2C44.6753 112.126 44.8124 110.165 45.187 108.588C45.3746 107.799 45.6386 107.034 45.9766 106.348C46.2569 105.779 46.7973 104.826 47.7409 104.097C49.6233 102.643 52.3282 102.99 53.7823 104.872C55.7609 107.434 53.7823 107.838 53.7823 111.158Z",
    fill: "#946555"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0101 114.935C29.9881 105.869 38.8023 101.588 43.5872 100.581L53.4087 121.357C49.2534 124.253 36.0321 124.001 33.0101 114.935Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_489_6182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 100,
    width: 22,
    height: 23
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0101 114.935C29.9881 105.869 38.8023 101.588 43.5872 100.581L53.4087 121.357C49.2534 124.253 36.0321 124.001 33.0101 114.935Z",
    fill: "#946555"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_489_6182)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_489_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.935 132.035C21.702 132.683 16.935 128.965 16.2876 123.733C15.6401 118.5 19.3574 113.733 24.5904 113.085C29.8233 112.438 34.5903 116.155 35.2377 121.388C35.8852 126.621 32.1679 131.388 26.935 132.035Z",
    fill: "#F46940"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0494 98.7865C54.0885 98.7352 54.0981 98.7226 54.0721 98.748C55.7725 97.0846 55.7635 93.0624 53.2387 91.3619C50.714 89.6614 48.8844 90.5598 47.184 92.2232C43.6732 95.6575 42.1745 102.249 43.5144 107.131C44.2202 109.702 45.9386 111.873 48.6498 113.276C50.7623 114.37 51.5161 112.136 52.6095 110.024C53.7029 107.912 54.722 106.72 52.6095 105.626C51.9387 105.279 51.863 105.003 51.8214 104.852L51.8211 104.851C51.7302 104.52 51.7072 103.874 51.9903 102.861C52.2632 101.885 52.7369 100.872 53.2387 100.012C53.6384 99.3265 53.9464 98.9218 54.0494 98.7865Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_489_6182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 90,
    width: 13,
    height: 24
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0494 98.7865C54.0885 98.7352 54.0981 98.7226 54.0721 98.748C55.7725 97.0846 55.7635 93.0624 53.2387 91.3619C50.714 89.6614 48.8844 90.5598 47.184 92.2232C43.6732 95.6575 42.1745 102.249 43.5144 107.131C44.2202 109.702 45.9386 111.873 48.6498 113.276C50.7623 114.37 51.5161 112.136 52.6095 110.024C53.7029 107.912 54.722 106.72 52.6095 105.626C51.9387 105.279 51.863 105.003 51.8214 104.852L51.8211 104.851C51.7302 104.52 51.7072 103.874 51.9903 102.861C52.2632 101.885 52.7369 100.872 53.2387 100.012C53.6384 99.3265 53.9464 98.9218 54.0494 98.7865Z",
    fill: "#946555"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_489_6182)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_489_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1112 94.2602C45.8783 94.9076 41.1113 91.1903 40.4638 85.9574C39.8164 80.7244 43.5337 75.9574 48.7666 75.31C53.9996 74.6626 58.7666 78.3798 59.414 83.6128C60.0615 88.8457 56.3442 93.6127 51.1112 94.2602Z",
    fill: "#F46940"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3197 106.448C57.436 105.326 55.2572 107.226 54.6242 107.811C52.8763 109.424 50.1514 109.315 48.538 107.567C46.9247 105.819 47.0337 103.094 48.7816 101.481C52.6493 97.9107 57.4004 96.2543 60.964 97.5585C63.4455 98.4666 65.916 99.8529 67.1723 103.37C67.9725 105.61 66.4181 108.572 64.2526 109.557C62.1287 110.522 59.3435 108.527 58.3197 106.448Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_489_6182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 97,
    width: 21,
    height: 13
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3197 106.448C57.436 105.326 55.2572 107.226 54.6242 107.811C52.8763 109.424 50.1514 109.315 48.538 107.567C46.9247 105.819 47.0337 103.094 48.7816 101.481C52.6493 97.9107 57.4004 96.2543 60.964 97.5585C63.4455 98.4666 65.916 99.8529 67.1723 103.37C67.9725 105.61 66.4181 108.572 64.2526 109.557C62.1287 110.522 59.3435 108.527 58.3197 106.448Z",
    fill: "#946555"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_489_6182)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_489_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5097 117.681C66.2767 118.328 61.5097 114.611 60.8623 109.378C60.2148 104.145 63.9321 99.3781 69.1651 98.7307C74.398 98.0832 79.165 101.8 79.8124 107.033C80.4599 112.266 76.7426 117.033 71.5097 117.681Z",
    fill: "#F46940"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_489_6182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 103,
    width: 23,
    height: 27
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7823 111.157C58.3546 117.777 61.7674 119.083 63.9861 120.601C66.2049 122.119 66.5608 123.99 65.8749 126.267C64.8815 129.567 61.7308 130.353 59.4532 129.667C54.1646 128.074 44.5366 119.145 45.0876 114.2C44.6753 112.125 44.8124 110.165 45.187 108.588C45.3746 107.798 45.6386 107.034 45.9766 106.348C46.2569 105.779 46.7973 104.825 47.7409 104.097C49.6233 102.642 52.3282 102.99 53.7823 104.872C55.7609 107.433 53.7823 107.838 53.7823 111.157Z",
    fill: "#946555"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_489_6182)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_489_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9767 139.59C61.7438 140.238 56.9768 136.521 56.3293 131.288C55.6819 126.055 59.3992 121.288 64.6321 120.64C69.865 119.993 74.632 123.71 75.2795 128.943C75.9269 134.176 72.2097 138.943 66.9767 139.59Z",
    fill: "#F46940"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_489_6182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 90,
    width: 13,
    height: 24
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0494 98.7865C54.0885 98.7352 54.0981 98.7226 54.0721 98.748C55.7725 97.0846 55.7635 93.0624 53.2387 91.3619C50.714 89.6614 48.8844 90.5598 47.184 92.2232C43.6732 95.6575 42.1745 102.249 43.5144 107.131C44.2202 109.702 45.9386 111.873 48.6498 113.276C50.7623 114.37 51.5161 112.136 52.6095 110.024C53.7029 107.912 54.722 106.72 52.6095 105.626C51.9387 105.279 51.863 105.003 51.8214 104.852L51.8211 104.851C51.7302 104.52 51.7072 103.874 51.9903 102.861C52.2632 101.885 52.7369 100.872 53.2387 100.012C53.6384 99.3265 53.9464 98.9218 54.0494 98.7865Z",
    fill: "#946555"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_489_6182)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M44.7206 112.291C43.5118 103.829 50.8906 99.0694 54.9199 97.5583C46.8609 100.58 44.771 107.38 42.8319 103.225C43.9651 109.898 45.9294 120.752 44.7206 112.291Z",
    fill: "#8B5C4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_489_6182",
    x: 73.5344,
    y: 91.8579,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_489_6182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_489_6182",
    x: 49.3584,
    y: 54.0827,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_489_6182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_489_6182",
    x: 28.9597,
    y: 77.5034,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_489_6182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_489_6182",
    x: 33.4929,
    y: 99.4131,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_489_6182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_489_6182",
    x: -4.93973,
    y: 91.8579,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_489_6182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_489_6182",
    x: 19.2365,
    y: 54.0827,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_489_6182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_489_6182",
    x: 39.635,
    y: 77.5034,
    width: 61.4048,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_489_6182"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_489_6182",
    x: 35.1018,
    y: 99.4131,
    width: 61.4051,
    height: 61.4048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.577,
    result: "effect1_foregroundBlur_489_6182"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparingService);
export default __webpack_public_path__ + "static/media/preparingService.304cff1579c4fb8bc193db9f969e9e82.svg";
export { ForwardRef as ReactComponent };